// Diese gemeinsame Konstante wird auch im Browser-Bundle verwendet. Eine
// serverseitige Umgebungsvariablen-Referenz würde dort zu
// `process is not defined`
// führen und beim PageSpeed-Lauf einen Browserfehler auslösen.
export const SITE_URL = "https://immozwerg.com";
export const DEFAULT_SOCIAL_IMAGE =
  `${SITE_URL}/assets/587a6bb9fbb5.webp`;

function extractGoogleDriveFileId(imageUrl: string): string | null {
  const value = imageUrl.trim();
  const queryMatch = value.match(/[?&]id=([a-zA-Z0-9_-]+)/);
  if (queryMatch) return queryMatch[1];

  const filePathMatch = value.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
  if (filePathMatch) return filePathMatch[1];

  return null;
}

/**
 * Liefert für Social-Crawler eine absolute, crawler-fähige Bild-URL.
 * Google-Drive-Bilder gehen über den OG-Proxy, alle sonstigen HTTPS-Bilder
 * bleiben unverändert. Ohne Titelbild greift ausschließlich der definierte
 * Website-Fallback.
 */
export function getSocialImageUrl(imageUrl: string | undefined | null): string {
  const source = imageUrl?.trim() ?? "";
  const driveFileId = extractGoogleDriveFileId(source);
  if (driveFileId) return `${SITE_URL}/api/og-image?id=${driveFileId}`;
  if (/^https:\/\//i.test(source)) return source;
  return DEFAULT_SOCIAL_IMAGE;
}
